<template>
  <b-row class="m-2">
    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
      <span><b>Título</b></span>
      <br />
      <span class="pos-left">{{ evento.DeTitulo }}</span>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
      <span><b>Tipo de Evento</b></span>
      <br />
      <span
        v-if="evento.TipoEvento"
        class="pos-left"
        v-html="evento.TipoEvento.DeTipoEvento"
      ></span>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
      <span><b>Descrição</b></span>
      <br />
      <span class="pos-left">{{ evento.DeDescricao }}</span>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
      <span><b>Período</b></span>
      <br />
      <span class="pos-left">{{
        formatData(evento.DtInicio) + " a " + formatData(evento.DtFim)
      }}</span>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="text-left mb-2">
      <span><b>Valor total dos gastos</b></span>
      <br />
      <span class="pos-left">{{
        `R$ ${evento.VlGastoTotal}`.replace(".", ",")
      }}</span>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { Evento } from "@/types/eventos/eventos/evento";

const CompProps = Vue.extend({
  name: "DetalhesDadosIniciaisEvento",
  props: {
    evento: {
      type: Evento,
      required: true,
    },
  },
});

@Component
export default class DetalhesDadosIniciaisEvento extends mixins(UtilsTS, CompProps) {}
</script>

<style></style>